const CategoryIcon = ({
  viewBox = "0 0 24 24",
  color = "#000",
  size = 24,
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="2424"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M933.376 693.646222l-239.672889 239.672889a112.981333 112.981333 0 0 1-159.800889 0L88.348444 487.822222A111.217778 111.217778 0 0 1 56.888889 398.904889V113.777778a56.888889 56.888889 0 0 1 56.888889-56.888889h285.127111a111.217778 111.217778 0 0 1 88.974222 31.345778l445.496889 445.496889a112.981333 112.981333 0 0 1 0 159.914666zM227.555556 170.666667a56.888889 56.888889 0 1 0 56.888888 56.888889 56.888889 56.888889 0 0 0-56.888888-56.888889z m548.750222 378.083555l-227.555556 227.555556 40.220445 40.220444 227.555555-227.555555z"
      fill={color}
      p-id="2425"
    ></path>
  </svg>
);

export default CategoryIcon;
